import { format } from "date-fns";

const defaultMonthDayYearFormat = "MMM dd yyyy";

export default function formatDate(
  dateString,
  formatString = defaultMonthDayYearFormat
) {
  if (!dateString) return;
  return format(new Date(dateString), formatString);
}
